import { getSystemIcon, SystemIcon } from '@helpers/icons';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
import S from './Controls.styles';
import { ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
const Controls = React.forwardRef((props, ref) => {
    const carousel = useCarouselContext();
    return (React.createElement(S.Container, { ref: ref, className: props.className, "aria-label": props.translations?.['global.carousel.controls'] ?? '', "data-variant": props.variant ?? ContentType.Default },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Button, { "aria-label": props.translations?.['global.carousel.previous'] ?? '', disabled: !props.wrap && carousel.activeIndex === 0, onClick: (event) => {
                    event.preventDefault();
                    carousel.goToPrev(props.wrap);
                }, "data-prev": true }, getSystemIcon(SystemIcon.ArrowRight))),
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Button, { "aria-label": props.translations?.['global.carousel.next'] ?? '', disabled: !props.wrap && carousel.activeIndex === carousel.maxIndex, onClick: (event) => {
                    event.preventDefault();
                    carousel.goToNext(props.wrap);
                }, "data-next": true }, getSystemIcon(SystemIcon.ArrowRight)))));
});
Controls.displayName = 'Controls';
export default Controls;
